<div class="container">
    <header class="header">
      <h1>AngularEditor</h1>
      <p>Native WYSIWYG editor for Angular 6+</p>    
    </header>
      <angular-editor [(ngModel)]="htmlContent" [config]="config"></angular-editor>
    <h5 class="html-header">HTML Output</h5>
    <div class="html">
      {{ htmlContent }}
    </div>
    <p>
</div>